// extracted by mini-css-extract-plugin
export default {"fields":"Ngm5GG","mobile":"_0JaSjA"};